import { useQuery } from '@hooks/reactQuery';

import { getProjectMembers } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROJECTS_MEMBERS } from '@constants/queryKeys';

interface IUseQueryProjectMembersReturned {
	projectMembers: TNameTitleValueLabel[];
	isLoadingProjectsMembers: boolean;
}

export const useQueryPlatformOwnerProjectMembers = (organizationId?: string): IUseQueryProjectMembersReturned => {
	const {
		data: projectMembers,
		isLoading: isLoadingProjectsMembers,
		isFetching: isFetchingProjectsMembers,
	} = useQuery({
		queryKey: [ORGANISATION_PROJECTS_MEMBERS, { organizationId }],
		queryFn: extractQueryParams(getProjectMembers),
		enabled: [organizationId],
		select: requestTypes => projectUsersFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		projectMembers: projectMembers || [],
		isLoadingProjectsMembers: isLoadingProjectsMembers || isFetchingProjectsMembers,
	};
};
